import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $clientAccountEdit,
  clientAccountEditMounted,
  updateClientAccountLeverage,
  $error,
  updateClientAccountSwapfree,
  archiveAccount,
} from './model'

export const useClientAccountEdit = () => {
  const clientAccountEdit = useStore($clientAccountEdit)
  // Отдельно вызываем useStore для каждого эффекта
  const leverageLoading = useStore(updateClientAccountLeverage.pending)
  const swapfreeLoading = useStore(updateClientAccountSwapfree.pending)
  const archiveLoading = useStore(archiveAccount.pending)

  // Объединяем результаты логическим "или"
  const loading = leverageLoading || swapfreeLoading || archiveLoading
  const error = useStore($error)

  React.useEffect(() => {
    clientAccountEditMounted()
  }, [])

  return { clientAccountEdit, loading, error }
}
